import { render, staticRenderFns } from "./ViewPackageComponent.vue?vue&type=template&id=2a8e3f8b&"
import script from "./ViewPackageComponent.vue?vue&type=script&lang=js&"
export * from "./ViewPackageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports